import { casesActions } from "configs";
import {
  generateId,
  useCurrentCase,
  useDispatch,
  useParams,
  useToast
} from "duck";
import { useCreateCurrentMedicationMutation } from "requests";
import { FormValues } from "../../form/duck";

export const useCreateMedication = (onSuccess: () => void) => {
  const { id: caseId } = useParams();
  const toast = useToast();

  const { shouldSync, patientId } = useCurrentCase(state => ({
    shouldSync: state.shouldSync,
    patientId: state.data.client.patient._id
  }));

  const dispatch = useDispatch();
  const [createMedication] = useCreateCurrentMedicationMutation({
    ignoreResults: true
  });

  return ({ medication, dose, lastGivenAt, frequency }: FormValues) => {
    if (!frequency || !lastGivenAt) {
      return;
    }

    const input = {
      dose,
      medication,
      lastGivenAt,
      frequency
    };

    if (shouldSync && patientId) {
      return createMedication({
        variables: { input: { patient: patientId, ...input } }
      }).then(response => {
        const med = response.data?.createCurrentMedication?.currentMedication;
        if (med) {
          dispatch(
            casesActions.addCurrentMedication({ _id: caseId, data: med })
          );
          onSuccess();
          toast({
            status: "success",
            description:
              "Medication patient is currently taking is created successfully."
          });
        }
      });
    }

    dispatch(
      casesActions.addCurrentMedication({
        _id: caseId,
        data: { ...input, fakeId: generateId() }
      })
    );
    onSuccess();
    toast({
      status: "success",
      description:
        "Medication patient is currently taking is created successfully."
    });
  };
};
